import { useContext, useEffect } from 'react'
import { UserContext, redirectToAuthWithFrom } from '../utils/UserContext'

const WrapAuthRoute = (props) => {
  const { user } = useContext(UserContext)
  useEffect(() => {
    if (!user.id) {
      redirectToAuthWithFrom()
    }
  }, [])
  return props.children
}

export default WrapAuthRoute
